<template>
  <div>
    <div style="font-size: 1.25rem" class="px-4 font-weight-bold mt-4">
      {{ $vuetify.lang.t("$vuetify.ai_response.items_search") }}
    </div>
    <v-card-text>
      {{ $vuetify.lang.t("$vuetify.ai_response.set_input_field_txt") }}
    </v-card-text>
    <v-form ref="recommend_form" class="ml-4">
      <v-row>
        <v-col cols="6" md="6" xs="12">
          <v-text-field type="text" v-model="user_id" :label='$vuetify.lang.t("$vuetify.ai_response.user_id")' dense outlined :rules="[
            required(
              $vuetify.lang.t('$vuetify.ai_response.user_id')
            ),
          ]">
          </v-text-field>
        </v-col>
        <v-col cols="6" md="6" xs="12">
          <v-btn class="mr-4 primary--text" outlined @click="generateUserUUID">
            {{ $vuetify.lang.t("$vuetify.ai_response.autogenerate") }}
          </v-btn>
        </v-col>
        <v-col cols="6" md="6" xs="12">
          <v-text-field type="text" v-model="member_id" :label='$vuetify.lang.t("$vuetify.ai_response.member_id")' dense outlined></v-text-field>
        </v-col>
        <v-col cols="6" md="6" xs="12">
          <v-btn class="mr-4 primary--text" outlined @click="generateMemberUUID">
            {{ $vuetify.lang.t("$vuetify.ai_response.autogenerate") }}
          </v-btn>
        </v-col>

        <v-col cols="6" md="6" xs="12">
          <v-text-field  v-model="searchText" dense :label='$vuetify.lang.t("$vuetify.ai_response.search_text")'
          :rules="[
            required(
              $vuetify.lang.t('$vuetify.ai_response.search_text')
            ),
          ]"
          outlined></v-text-field>
        </v-col>
        <v-col cols="6" md="6" xs="12">
          
        </v-col>
        <v-col cols="6" md="6" xs="12">
          <v-text-field type="number" v-model="price_lower" :label='$vuetify.lang.t("$vuetify.ai_response.lower_price")' dense outlined
          :rules="priceRules"></v-text-field>
        </v-col>
        <v-col cols="6" md="6" xs="12">
          
        </v-col>
        <v-col cols="6" md="6" xs="12">
          <v-text-field type="number" v-model="price_upper" :label='$vuetify.lang.t("$vuetify.ai_response.upper_price")' dense outlined
          :rules="priceRules"></v-text-field>
        </v-col>
        <v-col cols="6" md="6" xs="12">
          
        </v-col>
        <v-col cols="6" md="6" xs="12">
          <v-select v-model="type" :items="typeOptions" :label='$vuetify.lang.t("$vuetify.ai_response.type")' outlined dense
          >
          </v-select>
        </v-col>
        <v-col cols="6" md="6" xs="12">

        </v-col>

        <v-col cols="6" md="6" xs="12">
          <v-combobox
          v-model="categories"
          :items="allCategories"
          :label='$vuetify.lang.t("$vuetify.ai_response.categories")'
          variant="solo"
          chips
          clearable
          :hint="$vuetify.lang.t('$vuetify.ai_response.category_chip_hint')"
          outlined
          multiple
          dense
          :search-input.sync="searchInput"
          @keydown.enter="addCustomCategory"
          >
          <template v-slot:selection="{ attrs, item, select, selected }">
            <v-chip v-bind="attrs" :input-value="selected" close @click="select" @click:close="removeCategoryChip(item)" small>
              <span>{{ item }}</span>
            </v-chip>
          </template>
          
          <template v-slot:item="{ item, attrs, on }">
            <v-list-item v-on="on" v-bind="attrs">
              <v-list-item-action>
                <v-checkbox :input-value="categories.includes(item)"></v-checkbox>
              </v-list-item-action>
              <v-list-item-content>
                <v-list-item-title>{{ item }}</v-list-item-title>
              </v-list-item-content>
            </v-list-item>
          </template>

          <template v-slot:no-data>
            <v-list-item>
              <v-list-item-content>
                <v-list-item-title class="text--disabled">
                  {{ $vuetify.lang.t('$vuetify.common.no_data_available') || 'No data available' }}
                </v-list-item-title>
              </v-list-item-content>
            </v-list-item>
          </template>
        </v-combobox>
      </v-col>

        <v-col cols="6" md="6" xs="12">

        </v-col>
        
        <v-col cols="6" md="6" xs="12">
          <v-combobox
            v-model="dynamic_filtering"
            :items="allDynamic_filtering"
            :label='$vuetify.lang.t("$vuetify.ai_response.dynamic_filtering")'
            variant="solo"
            chips
            :hint="$vuetify.lang.t('$vuetify.ai_response.dynamic_filtering')"
            clearable
            outlined
            multiple
            dense
            >
            <template v-slot:selection="{ attrs, item, select, selected }">
              <v-chip v-bind="attrs" :input-value="selected" close @click="select" @click:close="removeDynamicFilteringChip(item)" small>
                <span>{{ item }}</span>
              </v-chip>
            </template>
            
            <template v-slot:item="{ item, attrs, on }">
              <v-list-item v-on="on" v-bind="attrs">
                <v-list-item-action>
                  <v-checkbox :input-value="dynamic_filtering.includes(item)"></v-checkbox>
                </v-list-item-action>
                <v-list-item-content>
                  <v-list-item-title>{{ item }}</v-list-item-title>
                </v-list-item-content>
              </v-list-item>
            </template>
            
            <template v-slot:no-data>
              <v-list-item>
                <v-list-item-content>
                  <v-list-item-title class="text--disabled">
                    {{ $vuetify.lang.t('$vuetify.common.no_data_available') || 'No data available' }}
                  </v-list-item-title>
                </v-list-item-content>
              </v-list-item>
            </template>
          </v-combobox>
        </v-col>
        <v-col cols="6" md="6" xs="12">
          <v-text-field type="text" v-model="language" :label='$vuetify.lang.t("$vuetify.ai_response.language")' dense outlined
          :rules="[
            required(
              $vuetify.lang.t('$vuetify.ai_response.language')
            ),
          ]"
          ></v-text-field>
        </v-col>
        <v-col cols="6" md="6" xs="12">
          <v-text-field type="number" v-model="start" :label='$vuetify.lang.t("$vuetify.ai_response.start")' dense outlined
          :rules="startRules"
          ></v-text-field>
        </v-col>
        <v-col cols="6" md="6" xs="12">
          <v-text-field type="number" v-model="size" :label='$vuetify.lang.t("$vuetify.ai_response.size")' dense outlined
          :rules="sizeRules"
          ></v-text-field>
        </v-col>
        
        <v-col cols="12">
          <span>{{$vuetify.lang.t("$vuetify.ai_response.flags")}}</span>
        </v-col>
        <v-col v-for="(flagItem) in mapper.flag" :key="flagItem" cols="6" md="6" xs="12">
          <v-select v-model="flags[flagItem]" :items="[true, false]" :label="flagItem" outlined dense
          >
          </v-select>
        </v-col>
        <v-col v-if="mapper.flag.length % 2 == 1" cols="6" md="6" xs="12">
          
        </v-col>
        <v-col cols="12">
          <span>{{ $vuetify.lang.t('$vuetify.ai_response.sort') }}</span>
        </v-col>
        <template v-for="(sortItem, index) in sortMapper">
            <v-col :key="`field-${index}`" cols="6" md="6" xs="12">
            <v-select 
              v-model="sortItem.fieldName" 
              :items="availableKeysForSortMapper(index, sortItem.fieldName)" 
              :label='$vuetify.lang.t("$vuetify.ai_response.key")' 
              outlined 
              dense
            >
            </v-select>
          </v-col>
          <v-col :key="`fieldName-${index}`" cols="6" md="6" xs="12">
            <v-select v-model="sortItem.sortType" :items="['asc', 'desc']" :label='$vuetify.lang.t("$vuetify.ai_response.select_sort_type")' outlined dense
            >
            </v-select>
          </v-col>
        </template>
        
        <v-col cols="12">
          <v-btn v-if="sortMapper.length > 1" class="text-capitalize float-right ml-2" @click="removeSortRow" color="primary" dark>
            <span class="">
              <v-icon>mdi-minus-circle-outline</v-icon>
            </span>
          </v-btn>
          <v-btn class="text-capitalize float-right" @click="addSortRow" color="primary" dark>
            <span class="">
              <v-icon>mdi-plus-circle-outline</v-icon>
            </span>
          </v-btn>
        </v-col>
        <v-col style="margin-bottom: -10px;" cols="12">
          <span >
            {{ $vuetify.lang.t('$vuetify.ai_response.date_range_filter') }}
          </span>
        </v-col>
      </v-row>
      <template v-if="catalogItems.length > 0">
        <v-row  v-for="(keyItem, index) in keys" :key="index">
          <v-col cols="4">
            <v-select
              clearable
              :label='$vuetify.lang.t("$vuetify.ai_response.key")'
              :items="availableKeysForField(index, keyItem.key, catalogItems)"
              outlined
              dense
              :value="keyItem.key"
              @input="onSelectChange(index, 'key', $event)"
              :rules="keyRules(keyItem.key, keyItem.comparator, keyItem.date)"
            ></v-select>
          </v-col>

          <!-- Comparator Selector -->
          <v-col cols="4">
            <v-select
              clearable
              :label='$vuetify.lang.t("$vuetify.ai_response.comparison_operator")'
              :items="filteredComparators(keyItem.key, index, keys).map(c => ({value: c, text: getComparatorText(c)}))"
              outlined
              dense
              v-model="keyItem.comparator"
              @input="onSelectChange(index, 'comparator', $event)"
              :rules="comparatorRules(index, keys)"
            ></v-select>
          </v-col>

          <!-- Date Picker -->
          <v-col cols="4">
            <v-menu
              v-model="keyItem.menu"
              max-width="290px"
              min-width="290px"
              :close-on-content-click="false"
              transition="scale-transition"
              offset-y
              outlined
              dense
            >
              <template v-slot:activator="{ on, attrs }">
                <v-text-field
                  @input="onSelectChange(index, 'date', $event)"
                  clearable
                  :label='$vuetify.lang.t("$vuetify.catalog.date")'
                  prepend-icon="mdi-calendar"
                  readonly
                  v-bind="attrs"
                  :value="keyItem.date"
                  outlined
                  v-on="on"
                  dense
                  :rules="dateRules(keyItem.key, keyItem.comparator, keyItem.date)"
                ></v-text-field>
              </template>
              <v-date-picker clearable v-model="keyItem.date"></v-date-picker>
            </v-menu>
          </v-col>
        </v-row>
        <v-row>
          <v-col cols="12" style="margin-top: -10px;">
            <v-btn class="text-capitalize float-right ml-2" v-if="keys.length > 1" @click="removeKey" color="primary" dark>
              <span class="">
                <v-icon>mdi-minus-circle-outline</v-icon>
              </span>
            </v-btn>
            <v-btn class="text-capitalize float-right" @click="addNewKey" color="primary" dark>
              <span class="">
                <v-icon>mdi-plus-circle-outline</v-icon>
              </span>
            </v-btn>
          </v-col>
        </v-row>
        <v-btn class="ml-2 mb-4" color="primary" @click="getRecommendedItems" dark>
          {{ $vuetify.lang.t("$vuetify.ai_response.get_response") }}
        </v-btn>
      </template>
    </v-form>
    <v-dialog v-model="openResponseModal" max-width="90%">
      <template v-if="responseLoading" >
        <Loader  class="mr-2 mt-6" />
      </template>
      <v-card v-else class="d-flex flex-column"
        style="overflow-y: scroll; overflow-x: hidden ; min-height: 80vh; position: relative;">
        <v-container>
          <div style="font-size: 1.25rem" class="font-weight-medium mt-8">
            {{ $vuetify.lang.t("$vuetify.ai_response.search_text") }}: <span style="font-size: 1 rem; margin-left: 10px;">{{ searchText }}</span>
          </div>
        </v-container>
        <v-container>
          <div style="font-size: 1.25rem" class="font-weight-medium mt-8">
            {{ $vuetify.lang.t("$vuetify.ai_response.search_items") }}
          </div>
        </v-container>
        <v-container>
          <v-row v-if="recommendedItems && recommendedItems.length > 0">
            <v-col v-for="product in recommendedItems" :key="product[mapper.item_id]" cols="12" md="3">
              <v-card class="product-card " @click="copyItemToClipBoard(product)" outlined>
                <v-img :src="product[mapper.image_url]" height="100px">
                  <template #placeholder>
                      <div class="d-flex align-center justify-center grey--text text-caption" style="height: 100%">
                        {{ $vuetify.lang.t("$vuetify.ai_response.image_not_available") }}
                      </div>
                  </template>
                </v-img>
                <div class="card-content">
                  <p class="ml-4">{{ product[mapper.title].slice(0, 50) }}</p>
                  <strong class="ml-4">¥ {{ product[mapper.price] }}</strong>
                </div>
              </v-card>
            </v-col>
          </v-row>
          <v-col v-else  class="d-flex align-items-center pa-0">
            <v-icon class="text-info mr-2">mdi-information</v-icon>
            <span class="text-body-1">
              {{ $vuetify.lang.t("$vuetify.ai_response.recommended_items_not_found") }}
            </span>
          </v-col>
        </v-container>
        <template>
          <v-container v-if="summaryKeywords.length" class="mt-4">
            <div
            style="font-size: 1.25rem; cursor: pointer; display: flex; align-items: center;"
            class="font-weight-medium mb-2"
            @click="expanded = !expanded"
            >
            <v-icon small class="mr-1">
              {{ expanded ? 'mdi-chevron-up' : 'mdi-chevron-down' }}
            </v-icon>
            {{ $vuetify.lang.t("$vuetify.ai_response.categories") }}
          </div>
          <div v-show="expanded">
            <v-row v-for="([key, values], index) in summaryKeywords" :key="index">
              <v-col cols="12">
                <strong>{{ key.replace(/_/g, " ") }}:</strong>
                <template v-if="values.length">
                  <v-chip
                  v-for="(val, idx) in values"
                  :key="idx"
                  :class="['ma-1', idx == 0 ? 'ml-3' : '']"
                  color="primary"
                  text-color="white"
                  small
                  >
                  {{ val }}
                </v-chip>
              </template>
              <span v-else> No data found</span>
            </v-col>
          </v-row>
        </div>
        </v-container>
      </template>
        <v-divider></v-divider>
        <v-card-title>
          <v-card-actions class="justify-end" style="position: absolute; bottom: 0; right: 0;">
            <v-btn color="primary" text @click="openResponseModal=false">
              {{ $vuetify.lang.t("$vuetify.ai_response.close") }}
            </v-btn>
          </v-card-actions>
        </v-card-title>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import { v4 as uuidv4 } from 'uuid';
import { ITEMS_SEARCH, ADD_ALERT } from "@/store/_actiontypes";
import { mapState, mapActions } from "vuex";
import Loader from "@/components/common/loader/Loader";
import { filteredComparators, comparatorRules, keyRules, dateRules, availableKeysForField, getComparatorText} from '../../Recommendation/shared_libs';
export default {
  components: {
    Loader
  },
  props: {
    mapper: {
      type: Object,
    },
    catalogItems: {
      type: Array
    }
  },
  data() {
    return {
      user_id: "",
      member_id: "",
      item_id: "",
      openModal: false,
      openResponseModal: false,
      recommendedItems : [],
      responseLoading: false,
      searchText: "",
      type: "individual",
      start: 0,
      size: 10,
      price_lower: 1,
      price_upper: 10000,
      typeOptions: ['individual', 'group'],
      sort: {},
      keys: [
        {key: "", date: "", comparator: "",  menu: false},
      ],
      priceRules: [
      value =>  value >= -1 || `${this.$vuetify.lang.t("$vuetify.ai_response.min_value_error")} 1`,
      ],
      categories: [],
      allCategories: [],
      searchInput: null,
      startRules: [
        value => value === "" || value >= 0 || `${this.$vuetify.lang.t("$vuetify.ai_response.min_value_error")} 0`,
      ],
      sizeRules: [
        value => value === "" || value >= 1 || `${this.$vuetify.lang.t("$vuetify.ai_response.min_value_error")} 1`,
      ],
      flags : {},
      dynamic_filtering: [],
      allDynamic_filtering: [],
      columnNames: [],
      columnName: "",
      sortType: "desc",
      sortMapper: [{fieldName: "", sortType: ""}],
      selectedKeys: {},
      language: "en",
      summaryKeywords: [],
      expanded: false,
    };
  },
  mounted(){
    this.getColumnNames()
    this.allCategories = this.extractCategoryNames(this.catalogItems);
    this.allDynamic_filtering = this.extractDynamicFilteringNames();
  },
  computed: {
    ...mapState({
      selectedProject: (state) => state.project.selectedProject,
      user: (state) => state.account.user
    }),
    catalogKeys(){
      const keys = Object.keys(this.catalogItems[0]?.item)
      return keys
    },
  },
  methods: {
    ...mapActions("ai_response", [ITEMS_SEARCH]),
    ...mapActions("alert", [ADD_ALERT]),
    availableKeysForField,
    getComparatorText,
    required(fieldName) {
      return (value) => !!value || `${fieldName} ${this.$vuetify.lang.t("$vuetify.ai_response.is_required")}`;
    },
    generateMemberUUID() {
      this.member_id = uuidv4()
    },
    generateUserUUID() {
      this.user_id = uuidv4()
    },
    copyItemToClipBoard(item){
      navigator.clipboard.writeText(JSON.stringify(item, null, 2));
      this.$store.dispatch(
                `alert/${ADD_ALERT}`, {
                  message: this.$vuetify.lang.t("$vuetify.ai_response.item_copied_message"),
                  color: "success",
                }, { root: true }
              );
    },
    availableKeysForSortMapper(index, selectedFieldName) {
      const keys = Object.keys(this.catalogItems[0]?.item)
      const availableKeys = keys.filter(key => {
          let selectedKey = false
          let data = {}
          this.sortMapper.forEach((sortItem, index) => {
            if(sortItem.fieldName === key){
              selectedKey = true
              data = {fieldName: key, index: index}
            }
          })
          if(!selectedKey)
            return true
          if(selectedKey && selectedFieldName != "" && data.fieldName === selectedFieldName)
            return true
          return false

      })
      return availableKeys
    },
    setItemId(itemId){
      this.item_id = itemId
      this.openModal = false
    },
    getColumnNames(){
        const keys = Object.keys(this.catalogItems[0].item)
        this.columnNames = keys
    },
    addSortRow(){
      this.sortMapper.push({fieldName: "", sortType: ""})
    },
    removeSortRow(){
      if(this.sortMapper.length > 1)
        this.sortMapper.pop()
    },
    addNewKey(){
      this.keys.push({key: "", date: "", comparator: "",  menu: false})
    },
    removeKey(){
      const keysLength = this.keys.length
      if(keysLength > 1){
        const key = this.keys[keysLength-1].key
        if(this.selectedKeys[key])
          this.selectedKeys[key] = this.selectedKeys[key] - 1
        this.keys.pop()
      }
    },
    removeCategoryChip(item){
      this.categories = this.categories.filter(category => category != item)
    },
    removeDynamicFilteringChip(item){
      this.dynamic_filtering = this.dynamic_filtering.filter(category => category != item)
    },
    onSelectChange(index, field, value) {
      if (value === null) {
        this.keys[index][field] = "";
      } else {
        this.keys[index][field] = value;
      }
      let keyValues = {}
        this.keys.forEach((key) => {
          if( key.key && keyValues[key.key] == null){
            keyValues[key.key] = 1
          }
          else if( key.key && keyValues[key.key] != null){
            keyValues[key.key] = keyValues[key.key] + 1
            const indexes = []
            this.keys.forEach((item, index)=> {
              if(item.key == key.key){
                indexes.push(index)
                return true
              }
              return false
            })
            const subStr = (this.keys[indexes[0]].comparator.includes("gt") && this.keys[indexes[1]].comparator.includes("gt")) || (this.keys[indexes[0]].comparator.includes("lt") && this.keys[indexes[1]].comparator.includes("lt"))
            if( subStr ){
              this.keys[indexes[1]].comparator = ""
            }
          }
        })
        this.selectedKeys = keyValues
        setTimeout(()=> {
          this.validateForm()
        }, 100)
    },
    filteredComparators,
    comparatorRules,
    keyRules,
    dateRules,
    getFormData(){
      return {
        member_id : this.member_id,
        user_id: this.user_id,
        item_id: this.item_id,

      }
    },
    validateForm() {
      return this.$refs.recommend_form.validate();
    },
    getRecommendedItems(){
      const valid = this.validateForm()
      if(!valid) return
      this.openResponseModal = true
      this.responseLoading = true
      const optionalPayloads = {}
      if(this.columnName){
        optionalPayloads.sort = {[this.columnName] : this.sortType}
      }

      if(Object.keys(this.flags).length > 0){
        optionalPayloads.flags = this.flags
      }
      if(this.dynamic_filtering.length > 0){
        optionalPayloads.dynamic_filtering = this.dynamic_filtering
      }
      const keys = {}
      this.keys.forEach(keyItem => {
          if(keys[keyItem.key] && keyItem.key)
            keys[keyItem.key] = {...keys[keyItem.key], key: keyItem.key, [keyItem.comparator] : keyItem.date}
          else if (keyItem.key)
            keys[keyItem.key] = {key: keyItem.key, [keyItem.comparator] : keyItem.date}
      })

      if(this.price_lower !== ""){
        optionalPayloads.price_lower = this.price_lower
      }
      if(this.price_upper !== ""){
        optionalPayloads.price_upper = this.price_upper
      }
  
      if(this.start !== ""){
        optionalPayloads.start = Number.parseInt(this.start)
      }
      if(this.size !== ""){
        optionalPayloads.size = Number.parseInt(this.size)
      }

      //sort mapping
      let sortData = {}
      this.sortMapper.forEach((sortItem)=> {
          if(sortItem.fieldName && sortItem.sortType)
            sortData = {...sortData, [sortItem.fieldName]: sortItem.sortType}
      })
      const date_range_filters = Object.values(keys)
      this.ITEMS_SEARCH({
        project_id: this.selectedProject.id,
        user_id: this.user_id,
        member_id: this.member_id,
        message: this.searchText,
        type: this.type,
        details: true,
        categories: this.categories,
        ...optionalPayloads,
        date_range_filters,
        sort: sortData,
        language: this.language,
      }).then(
        (response) => {
          this.responseLoading = false
          this.recommendedItems = response.data.detail.response
          this.getSummaryKeywords(response.data);
        },
        (error) => {
          console.error("error", error)
          if(error.status === 422){
            this.$store.dispatch(
                  `alert/${ADD_ALERT}`, {
                    message: JSON.stringify(error?.response?.data?.detail),
                    color: "error",
                  }, { root: true }
                );
          } else {
            this.$store.dispatch(
                  `alert/${ADD_ALERT}`, {
                    message: error?.response?.data?.detail?.response,
                    color: "error",
                  }, { root: true }
            );
          }
          this.openResponseModal = false
        }
      );
    },
    extractCategoryNames(response) {
      const categorySet = new Set();
      for (const product of response) {
        const categories = product.item?.product_categories;
        if (!categories) continue;
        let categoryList = [];
        
        if (Array.isArray(categories)) {
          categoryList = categories;
        } else if (typeof categories === 'string') {
          categoryList = categories.split(',').map(cat => cat.trim());
        }
        categoryList?.filter(Boolean).forEach(cat => categorySet.add(cat));
      }
      return [...categorySet].sort((a, b) => a.localeCompare(b));
    },
    addCustomCategory() {
      if (this.searchInput && this.searchInput.trim() && !this.categories.includes(this.searchInput.trim())) {
        this.categories = [...this.categories, this.searchInput.trim()];
        this.searchInput = null;
      }
    },
    extractDynamicFilteringNames() {
      if (!this.mapper.categories || !Array.isArray(this.mapper.categories)) return [];
      
      return this.mapper.categories.map(category => category?.name?.trim()).filter(name => name && name !== '')
    },
    getSummaryKeywords(response) {
      if (!response?.summary?.keywords) return [];
      const keywords = response.summary.keywords;
      this.summaryKeywords = Object.entries(keywords).map(([key, values]) => [key,Array.isArray(values) ? values : []]);
    }
  }
};
</script>

<style scoped>
        .product-card {
          height: 300px; 
          display: flex;
          flex-direction: column;
          justify-content: space-between;
          cursor: pointer;
        }
        .card-content {
          padding: 4px;
        }
    
        .card-content .v-card-title {
          margin-bottom: 0;
          font-size: 16px;
        }
    
        .card-content .v-card-subtitle {
          margin-bottom: 8px;
        }
</style>
